


import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Container,
  TextField,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  useMediaQuery,
  CircularProgress,
  Modal,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUser } from "../context/UserContext";
import {
  addSoldItemScanned,
  fetchSoldItemById,
  fetchItemsByOrgId,
  getAllItemListByBarCode
} from "../services/api";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import SpinnerLoading from "../utility/LoadingIndicator"

const SoldItems = () => {
  const [soldItems, setSoldItems] = useState([]);
  const [aggregatedSoldItems, setAggregatedSoldItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const { user } = useUser();
  const [items, setItems] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [scannedBarcode, setScannedBarcode] = useState('');
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg"));
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [scannedItems, setScannedItems] = useState([]);
  const [newSoldItem, setNewSoldItem] = useState({
    itemId: "",
    itemName: "",
    sold_stockQuantity: "",
    sold_cost: "",
    quantity_ml: "",
  });
  let itemNameRelatedToBarCode;

  //fetch items by orgId
  const fetchItems = async () => {
    if (!user || !user.orgId) return;

    try {
      const response = await fetchItemsByOrgId(user.orgId);
      console.log(response.data.data);

      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.data.data)
      ) {
        // Group items by itemName starting from the last index
        const groupedItems = response.data.data.reduceRight((acc, item) => {
          const existingItem = acc.find((i) => i.itemName === item.itemName);
          if (existingItem) {
            existingItem.item_stockQuantity += item.item_stockQuantity;
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, []);

        setItems(groupedItems);
        console.log("Grouped items:", groupedItems);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
      setItems([]);
    }
  };

  // fetch sold items by billId
  const fetchSoldItems = async () => {
    try {
      const response = await fetchSoldItemById(user.orgId);
      if (response && response.status === 200) {
        const soldItemsData = response.data.data;
        setSoldItems(soldItemsData);
        console.log("sold Items", soldItemsData);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };
  const fetchSoldItemsForAggregate = async () => {
    try {
      const response = await fetchSoldItemById(user.orgId);

      if (response && response.status === 200) {
        const soldItemsData = response.data.data;

        // Group items by itemName and sum up sold_stockQuantity
        const AggregatedSoldItems = soldItemsData.reduce((acc, item) => {
          const existingItem = acc.find((i) => i.itemName === item.itemName);
          if (existingItem) {
            existingItem.sold_stockQuantity += item.sold_stockQuantity;
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, []);

        setAggregatedSoldItems(AggregatedSoldItems);
        console.log("Aggregated sold items:", AggregatedSoldItems);
      }
    } catch (error) {
      console.error("Failed to fetch sold items:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchItems();
      await fetchSoldItems();

      setLoading(false);
    };
    fetchData();
  }, []);


  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "+" || event.keyCode === 107) {
        event.preventDefault(); // Prevent default behavior of the "+" key (if any)
        handleAdd(); // Call handleAdd directly
      }
    };

    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyPress);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);


  const calculateTotalValue = (quantity, price) => {
    return quantity * price;
  };

  const filteredSoldItems = Array.isArray(soldItems)
    ? soldItems.filter((item) =>
      item.itemName?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleOpen = () => {
    fetchSoldItemsForAggregate();

    setOpen(true);
    setNewSoldItem({
      itemId: "",
      sold_stockQuantity: "",
      sold_cost: "",
      quantity_ml: "",
    });
  };

  const handleClose = () => {
    setBarcode("");
    setOpen(false);
    setSelectedItem([]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewSoldItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  //items sell method
  const handleSellItem = async () => {

    // Prevent multiple submissions
    setIsSubmitting(true);
    try {
      console.log("scanned Items :", scannedItems)

      const response = await addSoldItemScanned(scannedItems);

      if ((response && response.status === 200) || 201) {
        toast.success("Sold item added successfully.");
        // setSoldItems((prevItems) => [...prevItems, newSoldItemEntry]);
        fetchSoldItems();
        fetchSoldItemsForAggregate();
        setSelectedItem([]);
        setIsSubmitting(false);
        setBarcode("");
        barcodeRef.current && barcodeRef.current.focus();
        setScannedItems([]);

      } else if (
        response.status === 400 ||
        response.message ===
        "Insufficient stock quantity. Cannot sell more than available."
      ) {
        toast.error(response.message);
      }

      setNewSoldItem({
        itemName: "",
        itemId: "",
        sold_stockQuantity: "",
        sold_cost: "",
        quantity_ml: "",
      });
      // handleClose();
    } catch (error) {
      console.error("Failed to add sold item:", error);
      toast.error("Failed to add sold item. Please try again.");
    }
    finally {
      // Re-enable the button after processing
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (scannedBarcode) {
        fetchItemDetails(scannedBarcode);
      }
    }, 500); // 500ms debounce delay

    return () => clearTimeout(timer); // Cleanup the timer on component unmount or input change
  }, [scannedBarcode]);

  const fetchItemDetails = async (barcodeValue) => {
    try {
      const response = await getAllItemListByBarCode(barcodeValue);
      const itemDetails = response.data[0];
      console.log("Item Details:", itemDetails);

      const itemNameRelatedToBarCode = `${itemDetails.itemsName} ${itemDetails.itemId}(${itemDetails.itemsUnits})`;
      const filterItemByBarCodeName = items.find(
        (item) => item.itemName === itemNameRelatedToBarCode
      );

      console.log("Grouped Items:", items);
      console.log("Filter Item By BarCode Name:", filterItemByBarCodeName);

      // If item is not found
      if (!filterItemByBarCodeName) {
        toast.warn(
          "Item not found for the provided barcode. Please add this barcode item to stocks before selling."
        );


        return; // Exit the function early
      }

      // If item is found
      setSelectedItem(filterItemByBarCodeName);
      setNewSoldItem({
        itemName: filterItemByBarCodeName.itemName,
        itemId: filterItemByBarCodeName.itemId,
        sold_cost: filterItemByBarCodeName.item_sellingCost || "", // Set cost directly
        quantity_ml: filterItemByBarCodeName.item_quantity || "", // Set quantity directly
      });
    } catch (error) {
      console.error("Error fetching item details:", error);
      toast.warn("This item barcode is not found in your item list. Please create item with this barcode...!");
      if (error.response.data.message === "Item not found" || barcode === "") {

        setSelectedItem([]);
        setNewSoldItem({
          itemName: "",
          itemId: "",
          sold_stockQuantity: "",
          sold_cost: "",
          quantity_ml: "",
        });
      }
    }
  };

  const handleRest = () => {
    setBarcode("");
    setSelectedItem([]);
    setNewSoldItem({
      itemName: "",
      itemId: "",
      sold_stockQuantity: "",
      sold_cost: "",
      quantity_ml: "",
    });
  }


  const handleSetSoldItemArray = () => {

    const {
      itemId,
      itemName,
      sold_stockQuantity,
      sold_cost,
      quantity_ml,
    } = newSoldItem;
    console.log(sold_stockQuantity);
    
    if(!itemId){
      toast.warn("Please  scan the item...! ");
      return;
    }
    if(!sold_stockQuantity ){
      toast.warn("Please  enter the sold Quanity...! ");
      return;
    } 
    if (sold_stockQuantity) {

      // Find the selected item from the items array
      const selectedItem = items.find(
        (item) => item.itemName === itemName
      );
      // Check if the selected item's stock is sufficient for the requested quantity
      if (
        sold_stockQuantity >
        selectedItem.item_stockQuantity -
        (soldItems.find(
          (soldItem) =>
            soldItem.itemName === selectedItem.itemName
        )?.sold_stockQuantity || 0)
      ) {
        console.log("Insufficient stock validation triggered.");

        // Calculate remaining stock
        const remainingStock =
          selectedItem.item_stockQuantity -
          (aggregatedSoldItems.find(
            (soldItem) =>
              soldItem.itemName === selectedItem.itemName
          )?.sold_stockQuantity || 0);

        // Display warning with remaining stock
        toast.warn(
          `Insufficient stock. Currently available beverages are ${remainingStock > 0 ? remainingStock : 0
          } only!`

        );
        setIsSubmitting(false);
        return;
      }
      const newSoldItemEntry = {
        sold_itemId: `${itemId}-${Date.now()}`,
        itemId,
        itemName,
        sold_stockQuantity: Number(sold_stockQuantity),
        sold_cost: Number(sold_cost),
        soldCreatedBy: user.userId,
        orgId: user.orgId,
        quantity_ml: Number(quantity_ml),
      };

      setScannedItems((prevItems) => [...prevItems, newSoldItemEntry]);
      setBarcode("");
      setSelectedItem([]);
      setNewSoldItem({
        itemName: "",
        itemId: "",
        sold_stockQuantity: "",
        sold_cost: "",
        quantity_ml: "",
      });
      barcodeRef.current && barcodeRef.current.focus();



    }

  }

  const handleBarcodeInput = (event) => {

    setBarcode("");
    setBarcode(event.target.value);
    setScannedBarcode(event.target.value); // Update debounce value



  };

  const barcodeRef = useRef();

  useEffect(() => {
    if (barcodeRef.current) {
      barcodeRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        barcodeRef.current && barcodeRef.current.focus();
      }, 100); // Adjust delay if needed
    }
  }, [open]);

  const handleAdd = () => {

    handleSetSoldItemArray();
  }

  // Method to handle deletion of an item
  const handleDelete = (index) => {
    setScannedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleCancelSellItem = () => {
    setScannedItems([]);
  }

  return (
    <>
    <style>
        {`
          @media (min-width: 1200px) {
            .css-5c1adp-MuiContainer-root {
              max-width: 100vw !important;
            }
          }
        `}
      </style>
    <Container>
      <ToastContainer />
      <Box sx={{ marginTop: 1, }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection={isMobile ? "column" : "row"}
          gap={2}
          sx={{ marginBottom: 1 }}
        >
          <Typography
            sx={{ color: "#024CAA" }}
            variant={isMobile ? "h6" : "h5"}
            gutterBottom
          >
            Sold Beverage Items
          </Typography>
          <TextField
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search by item name"
            sx={{
              input: { color: "#071952", padding: "8px" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#071952" },
                "&:hover fieldset": { borderColor: "#071952" },
                "&.Mui-focused fieldset": { borderColor: "#3572EF" },
              },
              width: isMobile ? "100%" : "32%",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon style={{ color: "#071952" }} />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpen}
            sx={{
              marginLeft: { xs: "auto", sm: "0px" },
              marginRight: { xs: "auto", sm: "0px" },
              marginTop: isMobile ? 1 : 0,
              width: { xs: "70%", sm: "auto" },
              textTransform: "none",
            }}
          >
            Sell Item
          </Button>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: isExtraLargeDevice
              ? 520 // Height for extra-large devices
              : isLargeDevice
                ? 420 // Height for large devices
                : 370, // Default height for other devices
            maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
            margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "6px",
            },
            "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Item Code
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Item Name
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Quantity(ml)
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Sales Quantity
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  MRP
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    color: "white",
                    backgroundColor: "#133E87",
                    fontWeight: "600",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Sales Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (<TableRow>
                <TableCell colSpan={7} align="center" sx={{ padding: 0, height: "60px" }}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%" // Spinner height inside table
                  >
                    <SpinnerLoading color="primary" />
                  </Box>
                </TableCell>
              </TableRow>) : filteredSoldItems.length > 0 ? (
                filteredSoldItems
                  .slice()
                  .reverse()
                  .map((item) => (
                    <TableRow key={item.sold_itemId}>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.itemId}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.itemName}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {`${item.quantity_ml}ml`}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.sold_stockQuantity}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        ₹ {item.sold_cost.toFixed(2)}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        ₹ {calculateTotalValue(
                          item.sold_stockQuantity,
                          item.sold_cost
                        ).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    sx={{ color: "#133E87" }}
                  >
                    No sales items found.
                  </TableCell>
                </TableRow>
              )}

            </TableBody>
          </Table>
        </TableContainer>

        {/* sold items modal */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="lg"
          fullWidth
          onEnter={() => barcodeRef.current && barcodeRef.current.focus()}
          onKeyDown={(e) => {
            if (e.key === "s") {
              e.preventDefault(); // Prevent default form submission behavior
              handleSellItem();
            }
            if (e.key === "Enter" ) {
              handleAdd();
            } 
          }}
          sx={{
            "& .MuiDialog-paper": {
              width: "90%",
              maxWidth: "90%",
              height: "90vh",
              
            },
          }}
        >
          <DialogTitle color="primary" fontSize={24}>
            Sale Item
          </DialogTitle>
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 12, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Box display="flex" gap={5}>
              {/* Sale Item Section */}
              <Box sx={{ width: "400px", padding: "50px 25px 50px 25px" , boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.5)",}} component={Paper}>

                <TextField
                  fullWidth
                  margin="normal"
                  label="Bar Code"
                  value={barcode}
                  onChange={handleBarcodeInput}
                  InputProps={{ inputProps: { min: 0 }, readOnly: false }}
                  InputLabelProps={{ shrink: true }}
                  required
                  inputRef={barcodeRef}
                  size="small"
                />
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Item Name"
                    name="itemName"
                    value={newSoldItem.itemName}
                    InputProps={{ inputProps: { min: 0 }, readOnly: true }}
                    InputLabelProps={{ shrink: true }}
                    required
                    size="small"
                  />
                </FormControl>
                <TextField
                  fullWidth
                  margin="normal"
                  size="small"
                  label={`Availble Quantity (${selectedItem.itemName
                    ? selectedItem.item_stockQuantity -
                    (aggregatedSoldItems.find(
                      (soldItem) => soldItem.itemName === selectedItem.itemName
                    )?.sold_stockQuantity || 0)
                    : 0
                    })`}
                  type="number"
                  name="sold_stockQuantity"
                  value={newSoldItem.sold_stockQuantity || ""}
                  onChange={(e) =>
                    setNewSoldItem((prevItem) => ({
                      ...prevItem,
                      sold_stockQuantity: e.target.value,
                    }))
                  }
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) =>
                    e.key === "ArrowUp" || e.key === "ArrowDown"
                      ? e.preventDefault()
                      : null
                  }
                  InputProps={{ inputProps: { min: 0 } }}
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label="Cost Price"
                  type="number"
                  name="sold_cost"
                  value={newSoldItem.sold_cost || ""}
                  InputProps={{ inputProps: { min: 0 }, readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  required
                  size="small"
                />
                <TextField
                  fullWidth
                  margin="normal"
                  label="Quantity (ml)"
                  type="number"
                  name="quantity_ml"
                  value={newSoldItem.quantity_ml || ""}
                  InputProps={{ inputProps: { min: 0 }, readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  size="small"
                />
                <Box sx={{ display: "flex", justifyContent: "center",marginTop:"10px" }}>
                  <Box>
                    <Button
                      style={{ background: "#ED3EF7" }}
                      onClick={handleRest}
                      variant="contained"
                      sx={{ marginRight: "10px", marginLeft: "730px",textTransform:"none" }}

                    >
                      Reset
                    </Button>
                  </Box>
                  <Box>
                    <Button onClick={handleAdd} color="primary" variant="contained" sx={{ marginRight: "530px",textTransform:"none" }}>
                      Add
                    </Button>
                  </Box>
                </Box>


              </Box>

              {/* Scanned Items Section */}
              <Box flex={1}>
                <TableContainer component={Paper} sx={{
                  maxHeight: isExtraLargeDevice
                    ? 450 // Height for extra-large devices
                    : isLargeDevice
                      ? 350 // Height for large devices
                      : 300, // Default height for other devices
                  maxWidth: isExtraLargeDevice ? "1400px" : "none", // Max-width cap for XL
                  margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                    height: "6px",
                  },
                  "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "6px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
                }}>
                  <Table stickyHeader>
                    <TableHead >
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}>Item Name</TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >Quantity (ml)</TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >Sold Cost</TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >Sold Stock Quantity</TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >Amount</TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            color: "white",
                            backgroundColor: "#133E87",
                            fontWeight: "600",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {scannedItems && scannedItems.length > 0 ? (
                        [...scannedItems].reverse().map((item, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ textAlign: "center" }}>{item.itemName}</TableCell>
                            <TableCell sx={{ textAlign: "center" }}>{item.quantity_ml}</TableCell>
                            <TableCell sx={{ textAlign: "center" }}>{item.sold_cost}</TableCell>
                            <TableCell sx={{ textAlign: "center" }}>{item.sold_stockQuantity}</TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {item.sold_stockQuantity * item.sold_cost}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              <Button color="error" size="small" onClick={() => handleDelete(index)}>
                                <DeleteIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} sx={{ textAlign: "center" , color:"#0A3981"}}>
                            No Scanned Items Found
                          </TableCell>
                        </TableRow>
                      )}


                    </TableBody>
                    <TableFooter>
                      <TableRow sx={{
                        textAlign: "center",
                        color: "white",
                        backgroundColor: "#133E87",
                        fontWeight: "600",
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}>
                        <TableCell colSpan={3} align="right" sx={{ color: "white", }}>

                        </TableCell>
                        <TableCell sx={{ color: "#FEEC37", fontSize: "16px", textAlign: "center" }}>
                          <strong>
                            {/* Total Items : */}
                            {" " + scannedItems.reduce((total, item) => total + item.sold_stockQuantity, 0)}
                          </strong>
                        </TableCell >
                        <TableCell sx={{ color: "#FEEC37", fontSize: "16px",minWidth:"150px", textAlign:"center"}}>
                          <strong>

                            {`₹ ${scannedItems.reduce(
                              (total, item) => total + item.sold_stockQuantity * item.sold_cost,
                              0
                            )}/-`}
                          </strong>
                        </TableCell>
                        <TableCell></TableCell> {/* Empty cell for alignment */}
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>


              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ margin: "0px 16px 14px 0px", }}>
            <Button onClick={handleCancelSellItem} color="primary" variant="outlined" sx={{textTransform:"none"}}>
              Cancel
            </Button>
            {isSubmitting ? (
              <Button sx={{backgroundColor:"#006BFF",borderRadius:"5px",marginTop:"5px", marginRight:"15px",marginBottom:"10px",textTransform:"none",color:"green"}} variant="outlined">
                <CircularProgress size={24} color="white" />
              </Button>
            ) : (
              <Button onClick={handleSellItem} color="primary" variant="contained" sx={{textTransform:"none"}}>
                Sell
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </Box>
    </Container>
    </>
  );
};

export default SoldItems;
